import { reportToTrackjs } from '../utils/report-to-trackjs';
import { userLoggedOut$ } from '../repositories/account-manager/account-manager.repository';
import { OrderNotificationEvent } from '../models/order-notification-event';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { from, Subject, Subscription } from 'rxjs';
import { accountsEnvironment } from '@tmx/data-access';
import { getCurrentAuthenticatedUser } from '@tmx/auth';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private connection: signalR.HubConnection | null = null;
  private connectionSubscription: Subscription | null = null;

  receiveOrderNotificationEvent$ = new Subject<OrderNotificationEvent>();

  constructor() {
    this.startSignalR();
    // No unsubscribe because we want to listen for entire app lifetime.
    userLoggedOut$.subscribe(() => {
      this.stopSignalR();
    });
  }

  private startSignalR() {
    this.stopSignalR();

    const authToken = getCurrentAuthenticatedUser().authToken;
    const url = `${accountsEnvironment.baseUrl}/api/v1/messages?authToken=${authToken}`;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .configureLogging(signalR.LogLevel.None)
      .build();

    this.connection.on(
      'ReceiveOrderNotification',
      (event: OrderNotificationEvent) => {
        this.receiveOrderNotificationEvent$.next(event);
      }
    );

    this.connectionSubscription = from(this.connection.start()).subscribe({
      error: () => {
        reportToTrackjs(
          'notification repository',
          'SignalR could not connect to hub.'
        );
      },
    });
  }

  private stopSignalR() {
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
      this.connectionSubscription = null;
    }

    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  }
}
